import { convertIGuideHtmlToLatex } from '../ast/util.html-to-latex.js';
import { convertInputToLatex } from './atom.input.js';

const html = String.raw;
const linebreak = convertIGuideHtmlToLatex("<br />");
function convertTaskToLatex(task, entry, args) {
  const heading = args.includeHeading ? convertIGuideHtmlToLatex(html`<h2>${task.title || `Trin ${args.taskIndex + 1}`}</h2>`.trim(), {
    allowAllHeadings: true
  }) : "";
  const guide = task.guide ? convertIGuideHtmlToLatex(task.guide) : undefined;
  const inputs = task.inputs.map(input => {
    const inputLatex = convertInputToLatex(input, entry, {
      taskId: task.id
    });
    if (inputLatex.length === 1) {
      return [...inputLatex, linebreak].join("");
    } else {
      return inputLatex.join("");
    }
  }).join(`${linebreak}`);
  return [heading, guide, inputs].filter(it => !!it).join(linebreak);
}

export { convertTaskToLatex };
//# sourceMappingURL=atom.task.js.map
